import React from 'react'
import styles from '../EmpoweringIndustries/EmpoweringIndustries.module.css'
// import HeroBar from '../../Components/HeroBar/HeroBar'
import HeroBar2 from '../../HeroBar/HeroBar2';
import AnimatedBtn from "../../AnimatedBtn/AnimatedBtn";
import StartNowBtn from "../../StartNowBtn/StartNowBtn";

const images = [
    { url: "/Images/Industry01.png", alt: "Team working with AI assistant" },
    { url: "/Images/Industry02.png", alt: "Developer workspace with laptop" },
    { url: "/Images/Industry03.png", alt: "People collaborating on project" },
    { url: "/Images/Industry04.png", alt: "Modern AI-driven call center" },
    { url: "/Images/Industry05.png", alt: "Customer support AI interface" },
    { url: "/Images/Industry06.png", alt: "Modern AI-driven call center" },
    { url: "/Images/Industry01.png", alt: "Team discussion on business strategy" },
    { url: "/Images/Industry02.png", alt: "AI system dashboard overview" },
    { url: "/Images/Industry03.png", alt: "Technology and analytics workspace" },
    { url: "/Images/Industry04.png", alt: "Coding and project collaboration" },
    { url: "/Images/Industry05.png", alt: "Business AI implementation team" },
    { url: "/Images/Industry06.png", alt: "AI system dashboard overview" },

];

// Split into two uneven columns
const leftImages = images.filter((_, i) => i % 2 === 0);
const rightImages = images.filter((_, i) => i % 2 !== 0);

const EmpoweringIndustries = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.LeftSection}>
                    <HeroBar2 title='Never Miss a Call, Lead or Client' subtitle="ABSOLUTE RELIABILITY: Never miss a single business lead to unavailability, day or night." titleMarginInline="unset"
                        titleWidth="100%"
                        titleTextAlign="left"
                        subtitleMarginInline="auto"
                        subtitleWidth="100%"
                        subtitleTextAlign="left"
                        subtitleJustifyContent="flex-start" showEllipse={false} />
                    <div className={styles.BtnDiv}>
                        <div>
                            {/* <AnimatedBtn text="Get Started for FREE" /> */}
                            <StartNowBtn
                                mainText="FREE SIGNUP"
                                subText="No Credit Card needed"
                                underline=""
                                bold=""
                            />
                        </div>
                        <div className={styles.PlayBtn}>
                            <img src='/Svg/Play-icon.svg' alt='Play-icon' />
                        </div>

                    </div>
                </div>
                <div className={styles.RightSection}>
                    <div className={styles.card}>
                        <div className={styles.scrollWrapper}>
                            <div className={styles.columns}>

                                {/* ✅ Left Column */}
                                <div className={styles.column}>
                                    {[...leftImages, ...leftImages].map((img, i) => (
                                        <div key={i} className={styles.leftImgBox}>
                                            <img
                                                src={img.url}
                                                alt={img.alt}
                                                onError={(e) => (e.target.style.opacity = 0.3)}
                                            />
                                        </div>
                                    ))}
                                </div>

                                {/* ✅ Right Column */}
                                <div className={styles.column}>
                                    {[...rightImages, ...rightImages].map((img, i) => (
                                        <div key={i} className={styles.rightImgBox}>
                                            <img
                                                src={img.url}
                                                alt={img.alt}
                                                onError={(e) => (e.target.style.opacity = 0.3)}
                                            />
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                        <div className={styles.bottomOverlay}></div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EmpoweringIndustries
